module.exports = __webpack_public_path__ + "static/media/argos.19f4825f.jpg";